import {
  isMissingOpenAnalystSessionError,
  requireOpenAnalystApiAccessToken,
} from "@/context/auth/broker"

export async function requireBillingOpenAnalystApiAccessToken() {
  try {
    return await requireOpenAnalystApiAccessToken()
  } catch (error) {
    if (!isMissingOpenAnalystSessionError(error)) throw error
    return await requireOpenAnalystApiAccessToken()
  }
}
